export const CHANGE_ACTIVE_TAB = 'CHANGE_FREEBET_ACTIVE_TAB';
export const CHANGE_DATE_BY_TYPE = 'CHANGE_FREEBET_DATE_BY_TYPE';
export const FETCH_FREEBET_LIST = 'FETCH_FREEBET_LIST';
export const SET_CURRENT_PAGE = 'SET_FREEBET_CURRENT_PAGE';
export const RESET_TO_INITIAL_STATE = 'RESET_FREEBETS_TO_INITIAL_STATE';

const resetToInitialState = () => {
  return {
    type: RESET_TO_INITIAL_STATE,
  };
};

const setCurrentPage = (currentPage) => {
  return {
    type: SET_CURRENT_PAGE,
    payload: { currentPage },
  };
};

const changeActiveTab = (activeTab) => {
  return {
    type: CHANGE_ACTIVE_TAB,
    payload: {
      activeTab,
    },
  };
};

const changeDateByType = (dateType, date) => {
  return {
    type: CHANGE_DATE_BY_TYPE,
    payload: {
      dateType,
      date,
    },
  };
};

const fetchFreebetsByFilter = (config = {}) => {
  return async (dispatch, getState, { AccountFreebetApi }) => {
    try {
      dispatch(fetchFreebetListPending());

      const {
        AccountFreebet: { limit, startDate, endDate, freebets, activeTab: _activeTab },
      } = getState();

      const activeTab = config?.activeTab || _activeTab;
      const { currentPage } = freebets[activeTab];
      const initialConfig = { activeTab, currentPage, limit, startDate, endDate };

      const { data: _data } = await AccountFreebetApi.getFreebetByFilter({
        ...initialConfig,
        ...config,
      });
      let data = _data[activeTab];
      const isNextPageAvailable = data?.length > limit;
      if (isNextPageAvailable) data = data.slice(0, limit);

      dispatch(fetchFreebetListSuccess({ data, isNextPageAvailable }));
    } catch (error) {
      dispatch(fetchFreebetListFailure(error));
      throw error;
    }
  };
};

const fetchAllFreebets = () => {
  return async (dispatch) => {
    dispatch(fetchFreebetListPending());

    try {
      const activeFreebetPromise = dispatch(fetchFreebetsByFilter());
      const historyFreebetPromise = dispatch(fetchFreebetsByFilter({ activeTab: 'history' }));
      const result = await Promise.all([activeFreebetPromise, historyFreebetPromise]);

      dispatch(fetchFreebetListFulfilled(result));
    } catch (error) {
      dispatch(fetchFreebetListFailure(error));
      throw error;
    }
  };
};

const fetchFreebetListFulfilled = (result = []) => {
  return {
    type: `${FETCH_FREEBET_LIST}_FULFILLED`,
    payload: { result },
  };
};

const fetchFreebetListSuccess = ({ data, isNextPageAvailable }) => {
  return {
    type: `${FETCH_FREEBET_LIST}_SUCCESS`,
    payload: { data, isNextPageAvailable },
  };
};

const fetchFreebetListPending = () => {
  return {
    type: `${FETCH_FREEBET_LIST}_PENDING`,
  };
};

const fetchFreebetListFailure = (error) => {
  return {
    type: `${FETCH_FREEBET_LIST}_FAILURE`,
    payload: { error },
  };
};

export {
  changeDateByType,
  fetchFreebetsByFilter,
  setCurrentPage,
  fetchAllFreebets,
  changeActiveTab,
  resetToInitialState,
};
